// Debounce is binded with Jquery to avoid resize event to be overriden
// Custom event "debounceResize" is dispatched in JavaScript 
$(window).on("resize", _.debounce( (event) => {
    window.dispatchEvent(new CustomEvent("debounceResize"));
}, 200) );